import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-rate',
  templateUrl: './rate.component.html',
  styleUrls: ['./rate.component.scss']
})
export class RateComponent implements OnInit {

  public rating;

  constructor(public dialogRef: MdDialogRef<RateComponent>) { }

  ngOnInit() {
  }

  onRatingChange(event){
    this.rating = event.rating;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/rate/rate.component.ts